import { Component } from '@angular/core';
import { TabViewModule } from "primeng/tabview";
import { CssUikitComponent } from "./css-uikit/css-uikit.component";
import { AiChartsUikitComponent } from "./ai-charts-uikit/ai-charts-uikit.component";
import {DashboardUikitComponent} from "./dashboard-uikit/dashboard-uikit.component";

@Component({
  selector: 'app-uikit',
  standalone: true,
  templateUrl: './uikit.component.html',
  imports: [TabViewModule, CssUikitComponent, AiChartsUikitComponent, DashboardUikitComponent]
})
export class UikitComponent {}
